import BriefcaseIconWithColor from "../../assets/images/BriefcaseIconWithColor";
import EditIconWithColor from "../../assets/images/EditIconWithColor";
import {
  Constants,
  OnboardConstants,
  StaffListConstants,
} from "../../constants/constants";
import EducationalDetailsTable from "./EducationalDetailsTable";
import RolesAndPermissionTable from "./RolesAndPermissionTable";
import { TextFeild } from "./TextFeild";
import WorkExperienceTable from "./WorkExperienceTable";
import PersonalInformationDynamic from "./PersonalInformationDynamic";
import RolesAndPermissionIconWithColor from "../../assets/images/RolesAndPermissionIconWithColor";
import BranchesIcon from "../../assets/images/BranchesIcon";
import { getButtonName, getButtonLabel, SubSegment } from "./DynamicUserDeatil";
import ProfileIcon3 from "../../assets/images/ProfileIcon3";
import BankDetailIcon from "../../assets/images/BankDetailIcon";
import React from "react";
import { maskBankValue } from "../../utils/validationUtils";
export const componentMap: Record<
  number,
  { label: string; icon: React.ComponentType }
> = {
  0: {
    label: StaffListConstants.PersonalInformation,
    icon: ProfileIcon3,
  },
  3: {
    label: OnboardConstants.BankAccountDetails,
    icon: BankDetailIcon,
  },
};

export const MobileResponsiveUserDetail = ({
  showSaveEducationButton,
  handelSaveEducationalDetails,
  handelCancelEducationalDetails,
  handelAddmoreEditEducationalDetails,
  handleEditEducationalInformation,
  editModeForEducationalDetails,
  educationalDetailsIndex,
  order,
  addMoreEducationalInfo,
  setEditPayloadjson,
  jsonForEditData,
  updatedJsonObj,
  showEducationTableInEditFlow,
  showSaveWorkButton,
  handelSaveWorkDetails,
  handelCancelWorkDetails,
  handelAddmoreEditWorkDetails,
  handleEditWorkInformation,
  workDetailsIndex,
  addMoreWorkInfo,
  showWorkTableInEditFlow,
  showSaveTrainingButton,
  handelSaveTrainingDetails,
  handelCancelTrainingDetails,
  trainingCertifications,
  jsonForTrainingCertification,
  EditModeForTrainingCertification,
  handelEditTrainingCertification,
  showSaveRolesButton,
  handelSaveRolesDetails,
  handelCancelRolesDetails,
  handelAddmoreEditRolesDetails,
  editModeForWorkDetails,
  editModeForRolesDetails,
  rolesDetailsIndex,
  addMoreRolesInfo,
  showRolesTableInEditFlow,
  branches,
  handelEditBranchesCertification,
  showSaveBranchesButton,
  addMoreRoles,
  handelSaveBranchesDetails,
  jsonForBranchesCertification,
  EditModeForBranchesCertification,
  handelCancelBranchesDetails,
  isSaveButtonCLicked,
  setIsSaveButtonClicked,
  errors,
  setErrors,
}: any) => {
  return (
    <div>
      <div className="px-2  ">
        <div>
          {updatedJsonObj[order]?.name ===
            "Educational Information and Work Experience" && (
            <div>
              <div className="flex justify-between items-center mb-4">
                <div className="flex">
                  <EditIconWithColor />
                  <div className="pl-2 text-loginSubTitle font-poppins font-semibold ">
                    Education Info
                  </div>
                </div>
                <div className="flex gap-2">
                  {showSaveEducationButton && (
                    <button
                      className="ml-12 bg-primary px-3 text-sm text-whiteColor rounded-lg text-center"
                      onClick={handelCancelEducationalDetails}
                    >
                      Cancel
                    </button>
                  )}
                  <button
                    className=" bg-primary text-whiteColor whitespace-nowrap px-4 py-2 border border-primary rounded-lg"
                    onClick={
                      showSaveEducationButton
                        ? handelSaveEducationalDetails
                        : handelAddmoreEditEducationalDetails
                    }
                  >
                    {getButtonName(showSaveEducationButton)}
                  </button>
                </div>
              </div>
              <EducationalDetailsTable
                userDetail={updatedJsonObj}
                handleEditEducationalInformation={
                  handleEditEducationalInformation
                }
                editModeForEducationalDetails={editModeForEducationalDetails}
                educationalDetailsIndex={educationalDetailsIndex}
                order={order}
                addMoreEducationalInfo={addMoreEducationalInfo}
                setEditPayloadjson={setEditPayloadjson}
                jsonForEditData={jsonForEditData}
                isEditMode={true}
                showEducationTableInEditFlow={showEducationTableInEditFlow}
                isSaveButtonCLicked={isSaveButtonCLicked}
                setIsSaveButtonClicked={setIsSaveButtonClicked}
                errors={errors}
                setErrors={setErrors}
              />
              <div className="flex justify-between items-center pt-6 gap-8 mb-4">
                <div className="flex">
                  <BriefcaseIconWithColor />
                  <div className="pl-4 text-loginSubTitle font-poppins font-semibold">
                    {OnboardConstants.WorkExperience}
                  </div>
                </div>
                <div className="flex ">
                  {showSaveWorkButton && (
                    <button
                      className="bg-primary px-3 text-sm text-whiteColor py-2 rounded-lg"
                      onClick={handelCancelWorkDetails}
                    >
                      {"Cancel"}
                    </button>
                  )}
                  <button
                    className=" bg-primary text-whiteColor whitespace-nowrap px-4 py-2 border border-primary rounded-lg"
                    onClick={
                      showSaveWorkButton
                        ? handelSaveWorkDetails
                        : handelAddmoreEditWorkDetails
                    }
                  >
                    {getButtonName(showSaveWorkButton)}
                  </button>
                </div>
              </div>
              <WorkExperienceTable
                userDetail={updatedJsonObj}
                handleEditWorkInformation={handleEditWorkInformation}
                editModeForWorkDetails={editModeForWorkDetails}
                workDetailsIndex={workDetailsIndex}
                order={order}
                addMoreWorkInfo={addMoreWorkInfo}
                setEditPayloadjson={setEditPayloadjson}
                jsonForEditData={jsonForEditData}
                isEditMode={true}
                showWorkTableInEditFlow={showWorkTableInEditFlow}
                isSaveButtonCLicked={isSaveButtonCLicked}
                setIsSaveButtonClicked={setIsSaveButtonClicked}
                errors={errors}
                setErrors={setErrors}
              />
              <div className="pt-4">
                <div className="flex justify-between items-center mb-4">
                  <div className="flex ">
                    <BranchesIcon />
                    <div className="pl-4 text-loginSubTitle font-poppins font-semibold">
                      Training
                    </div>
                  </div>
                  <div className="flex gap-2">
                    {showSaveTrainingButton && (
                      <button
                        className="ml-12 bg-primary px-4 text-whiteColor text-sm rounded-lg"
                        onClick={handelCancelTrainingDetails}
                      >
                        {"Cancel"}
                      </button>
                    )}
                    <button
                      className=" bg-primary text-whiteColor whitespace-nowrap px-4 py-2 border border-primary rounded-lg"
                      onClick={
                        showSaveTrainingButton
                          ? handelSaveTrainingDetails
                          : handelEditTrainingCertification
                      }
                    >
                      {getButtonLabel(
                        showSaveTrainingButton,
                        trainingCertifications
                      )}
                    </button>
                  </div>
                </div>
              </div>
              {EditModeForTrainingCertification ? (
                <div>
                  <PersonalInformationDynamic
                    jsonobj={[jsonForTrainingCertification]}
                    order={0}
                    isEditMode={true}
                    setEditPayloadjson={setEditPayloadjson}
                  />
                </div>
              ) : (
                <div className="fields grid grid-cols-1 md:grid-cols-3 gap-4 pt-6">
                  {updatedJsonObj[order]?.subSegments?.map(
                    (subSegment: SubSegment) => {
                      return subSegment?.attributes
                        .filter((attribute) => attribute.name !== "face") // Exclude "face" attributes
                        .map(
                          (attribute) =>
                            attribute.name === "trainingCertifications" && (
                              <div
                                className="pb-2"
                                key={`key ${attribute.attributeId}`}
                              >
                                <TextFeild
                                  textFeildName={attribute?.label}
                                  placeholder={
                                    attribute.value?.length > 0
                                      ? attribute.value
                                          .map((item: any) => item.title)
                                          .join(", ") // Convert array to string
                                      : ""
                                  }
                                />
                              </div>
                            )
                        );
                    }
                  )}
                </div>
              )}
            </div>
          )}
          {updatedJsonObj[order]?.name ===
            "Roles, Applications and Permissions" && (
            <div>
              <div className="flex justify-between gap-8 mb-2">
                <div className="flex">
                  <RolesAndPermissionIconWithColor />
                  <div className="pl-4 text-loginSubTitle font-poppins font-semibold">
                    {Constants.Roles}
                  </div>
                </div>
                <div className="flex gap-2">
                  {showSaveRolesButton && (
                    <button
                      className="p-2 bg-primary px-4 text-sm text-whiteColor  rounded-lg"
                      onClick={handelCancelRolesDetails}
                    >
                      Cancel
                    </button>
                  )}
                  <div
                    className=" bg-primary whitespace-nowrap text-whiteColor px-2 py-1 border border-primary rounded-lg"
                    onClick={
                      showSaveRolesButton
                        ? handelSaveRolesDetails
                        : handelAddmoreEditRolesDetails
                    }
                  >
                    {getButtonName(showSaveRolesButton)}
                  </div>
                </div>
              </div>
              <RolesAndPermissionTable
                userDetail={updatedJsonObj}
                handleEditRolesInformation={handleEditWorkInformation}
                editModeForRolesDetails={editModeForRolesDetails}
                rolesDetailsIndex={rolesDetailsIndex}
                order={order}
                addMoreRolesInfo={addMoreRolesInfo}
                setEditPayloadjson={setEditPayloadjson}
                jsonForEditData={jsonForEditData}
                isEditMode={true}
                showRolesTableInEditFlow={showRolesTableInEditFlow}
                addMoreRoles={addMoreRoles}
                isSaveButtonCLicked={isSaveButtonCLicked}
                setIsSaveButtonClicked={setIsSaveButtonClicked}
                errors={errors}
                setErrors={setErrors}
              />
              <div className="flex justify-between pt-6">
                <div className="flex">
                  <BranchesIcon />
                  <div className="pl-4 text-loginSubTitle font-poppins font-semibold">
                    {"Branches"}
                  </div>
                </div>
                <div className="flex">
                  {showSaveBranchesButton && (
                    <div
                      className="ml-12 bg-primary px-4 text-whiteColor py-1  rounded-lg"
                      onClick={handelCancelBranchesDetails}
                    >
                      {"Cancel"}
                    </div>
                  )}
                  <div
                    className="ml-6 bg-primary text-whiteColor px-2 py-1 border border-primary rounded-lg"
                    onClick={
                      showSaveBranchesButton
                        ? handelSaveBranchesDetails
                        : handelEditBranchesCertification
                    }
                  >
                    {getButtonLabel(showSaveBranchesButton, branches)}
                  </div>
                </div>
              </div>
              {EditModeForBranchesCertification ? (
                <div>
                  <PersonalInformationDynamic
                    jsonobj={[jsonForBranchesCertification]}
                    order={0}
                    isEditMode={true}
                    setEditPayloadjson={setEditPayloadjson}
                  />
                </div>
              ) : (
                <div className="fields grid grid-cols-1 md:grid-cols-3 gap-4 pt-8">
                  {updatedJsonObj[order]?.subSegments?.map(
                    (subSegment: SubSegment) => {
                      return subSegment.attributes
                        .filter((attribute) => attribute.name !== "face") // Exclude "face" attributes
                        .map(
                          (attribute) =>
                            attribute.name === "branches" && (
                              <div
                                className="pb-2"
                                key={`key ${attribute.attributeId}`}
                              >
                                <TextFeild
                                  textFeildName={attribute.label}
                                  placeholder={
                                    attribute.value?.length > 0
                                      ? attribute.value
                                          .map((branch: any) => branch.name)
                                          .join(", ") // Join names with commas
                                      : ""
                                  }
                                />
                              </div>
                            )
                        );
                    }
                  )}
                </div>
              )}
            </div>
          )}
          <div className="flex mb-8 pb-2 border-b">
            {componentMap[order]?.icon &&
              React.createElement(componentMap[order]?.icon)}
            <div className="ml-3 text-loginSubTitle selectedMenu font-poppins font-semibold">
              {componentMap[order]?.label}
            </div>
          </div>
          <div className="fields grid grid-cols-2 md:grid-cols-3 justify-start gap-4 ">
            {updatedJsonObj[order]?.subSegments?.map(
              (subSegment: SubSegment) => {
                <div>{subSegment.name}</div>;

                return subSegment.attributes.map(
                  (attribute) =>
                    updatedJsonObj[order]?.name !==
                      "Educational Information and Work Experience" &&
                    updatedJsonObj[order]?.name !==
                      "Roles, Applications and Permissions" &&
                    attribute.value != null && (
                      <div
                        className="pb-4"
                        key={`key ${attribute.attributeId}`}
                      >
                        <TextFeild
                          textFeildName={attribute.label}
                          placeholder={
                            updatedJsonObj[order]?.name ===
                            "Bank account details"
                              ? maskBankValue(attribute.value)
                              : attribute.value
                              ? String(attribute.value)
                              : ""
                          }
                          isAndroid={true}
                        />
                      </div>
                    )
                );
              }
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
